/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormClipboardImage from "../../../shared/forms/FormFields/FormClipboardImage";
import Cobro from "../Edicion/cobro";
import {Button} from "primereact/button";
import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import numeral from "numeral";
import _ from "lodash";


const Cargos = ({ value, onChange, onValidate, puedeEditar, onRefresh,onSaved }) => {
   console.log(value )
    const [cobrar, setCobrar] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    // const quitar = async (cargoId, eliminar) => {
    //     if ((await alerts.preguntarSiNo("¿Desea eliminar el cargo?")) === true) {
    //         eliminar();
    //         await api.quitarCargo(value?.id, cargoId);
    //         onRefresh();
    //     }
    // };
    const handleCobrar = (row) => {
        console.log(row)
        setSelectedRow(row);
        setCobrar(true); 
    };
    return (
        <Form columns={1} values={value} onChange={onChange} onValidate={onValidate}
            formDisabled={value?.id > 0 || !puedeEditar}>
            <Field field={'cargos'} cols={5}
                render={({ value, onParentChange, ...props }) =>
                    <ExGrid {...props} data={value} getEntityId={(row) => row._uniqueUid} formDisabled={true}
                        onChange={(data) => onParentChange({ cargos: data, costo: _.sumBy(data, 'costo') })}>
                        <ExColumn field="departamento" title={'Departamento'} width={'25%'} />
                        <ExColumn field="concepto" title={'Concepto'} width={'15%'} />
                        <ExColumn field="comentarios" title={'Comentarios'} width={'30%'} />
                        <ExColumn field="costo" title={'Costo'}
                            cellRenderer={({ row }) => <span>{numeral(row?.costo).format('$0,0.00')}</span>} width={'10%'} />
                        <ExColumn field="evidencia" title={'Evidencia'} cellRenderer={FormClipboardImage} width={'10%'}
                            disabled={true} />
                       <ExColumn
                            field="command"
                            width="10%"
                            cellRenderer={({ row }) =>
                                !row.cobrado && (
                                    <Button label="Cobrar" type="button" onClick={() => handleCobrar(row)} />
                                )
                            }
                        />

                        {/* <ExColumn field="command" width={'5%'}
                            cellRenderer={({ row, onDelete }) => { !row.cobrado && <DeleteButton onDelete={() => quitar(row.id, onDelete)} /> }} /> */}
                    </ExGrid>}>
            </Field>
            <Field label="Costo Total" field={"costo"}
                render={({ value }) => <span className="bold">{numeral(value).format('$0,0.00')}</span>} />
                {cobrar && (
                <Cobro 
                    visible={cobrar} 
                    onClose={() => setCobrar(false)} 
                    cargo={selectedRow}
                    onSaved={() => {
                        onSaved();
                        setCobrar(false);
                    }} 
                    incidenciaId={value.id}
                />
            )}

        </Form>

        
    );
};

export default Cargos;
